import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/user-circle': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 104c53 0 96 43 96 96s-43 96-96 96-96-43-96-96 43-96 96-96zM248 248c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c49.7 0 95.1-18.3 130.1-48.4-14.9-23-40.4-38.5-69.6-39.5-20.8 6.5-40.6 9.6-60.5 9.6s-39.7-3.2-60.5-9.6c-29.2 0.9-54.7 16.5-69.6 39.5 35 30.1 80.4 48.4 130.1 48.4zM410.7 371.9c23.4-32.7 37.3-72.7 37.3-115.9 0-110.3-89.7-200-200-200s-200 89.7-200 200c0 43.2 13.9 83.2 37.3 115.9 24.5-31.4 62.2-51.9 105.1-51.9 10.2 0 26.1 9.6 57.6 9.6 31.6 0 47.4-9.6 57.6-9.6 43 0 80.7 20.5 105.1 51.9z'
      }
    ]
  }
})
